import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "./config";
import { loadSubscriptionPlaces } from "./places";

const H = {
  title: "\u05d1\u05d7\u05d9\u05e8\u05ea \u05d7\u05e0\u05d9\u05d5\u05df",
  loading: "\u05d8\u05d5\u05e2\u05df \u05d7\u05e0\u05d9\u05d5\u05e0\u05d9\u05dd...",
  search: "\u05d7\u05d9\u05e4\u05d5\u05e9 \u05d7\u05e0\u05d9\u05d5\u05df",
  placeholder: "\u05d4\u05e7\u05dc\u05d3 \u05e9\u05dd \u05d7\u05e0\u05d9\u05d5\u05df",
  noPlaces: "\u05dc\u05d0 \u05e0\u05de\u05e6\u05d0\u05d5 \u05d7\u05e0\u05d9\u05d5\u05e0\u05d9\u05dd",
  chooseError: "\u05d9\u05e9 \u05dc\u05d1\u05d7\u05d5\u05e8 \u05d7\u05e0\u05d9\u05d5\u05df \u05de\u05d4\u05e8\u05e9\u05d9\u05de\u05d4",
  perMonth: "\u05dc\u05d7\u05d5\u05d3\u05e9",
  continue: "\u05d4\u05de\u05e9\u05da",
  currency: "\u20aa",
};

export default function PlaceSelection() {
  const navigate = useNavigate();
  const [places, setPlaces] = useState([]);
  const [query, setQuery] = useState("");
  const [selectedPlaceId, setSelectedPlaceId] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let ignore = false;
    loadSubscriptionPlaces(config.apiUrl)
      .then((list) => {
        if (ignore) return;
        setPlaces(list);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, []);

  const filteredPlaces = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return places;
    return places.filter((place) => String(place.name || "").toLowerCase().includes(q));
  }, [places, query]);

  const selectedPlace = places.find((place) => place.id === selectedPlaceId);
  const showDropdown = dropdownOpen && !loading;

  const continueToSubscription = () => {
    setError("");
    if (!selectedPlace) {
      setError(H.chooseError);
      return;
    }
    navigate(`/subscription?place-id=${encodeURIComponent(selectedPlace.id)}`);
  };

  return (
    <main className="page" dir="rtl">
      <section className="panel">
        <img src="/logo.png" alt="Blue Parking" className="logo" />
        <h1>{H.title}</h1>

        {loading ? (
          <p className="muted">{H.loading}</p>
        ) : (
          <div className="form">
            <label className="place-dropdown">
              {H.search}
              <input
                value={query}
                onFocus={() => setDropdownOpen(true)}
                onBlur={() => setTimeout(() => setDropdownOpen(false), 120)}
                onChange={(event) => {
                  setQuery(event.target.value);
                  setSelectedPlaceId("");
                  setDropdownOpen(true);
                  setError("");
                }}
                placeholder={H.placeholder}
                autoComplete="off"
              />

              {showDropdown ? (
                <div className="place-dropdown-menu">
                  {filteredPlaces.map((place) => (
                    <button
                      key={place.id}
                      type="button"
                      className={`place-option ${selectedPlaceId === place.id ? "selected" : ""}`}
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => {
                        setSelectedPlaceId(place.id);
                        setQuery(place.name);
                        setDropdownOpen(false);
                        setError("");
                      }}
                    >
                      <span>{place.name}</span>
                      <strong>{Number(place.monthlyPrice || 0).toLocaleString("he-IL")} {H.currency} {H.perMonth}</strong>
                    </button>
                  ))}
                  {!filteredPlaces.length ? <p className="muted dropdown-empty">{H.noPlaces}</p> : null}
                </div>
              ) : null}
            </label>

            {error ? <p className="error">{error}</p> : null}

            <button type="button" onClick={continueToSubscription}>
              {H.continue}
            </button>
          </div>
        )}
      </section>
    </main>
  );
}
